import dynamic from "next/dynamic";

export const DynamicContent060 = dynamic(() => import("./Content060"), {
  suspense: true,
});
